import { Form } from "antd";

import ProgressBar from "@/components/Elements/ProgressBar";

const ProgressEditField = ({
  name = "progress",
  label = "",
  ...progressBarProps
}) => (
  <Form.Item name={name} label={label}>
    <ProgressBar {...progressBarProps} isEditable />
  </Form.Item>
);

export default ProgressEditField;
